import { EuiFieldText, EuiFieldPassword, EuiFieldSearch, EuiText } from '@elastic/eui';
import { G } from 'enums';
import { ValueOf } from 'types';

export interface FormFieldProps {
  readonly onChange: (value: FormFieldProps['value']) => void;
  readonly value: string;
  readonly label: string;
  readonly name: ValueOf<typeof G>;
  readonly placeholder?: string;
  readonly helpText?: string;
  readonly type: 'Text' | 'Password' | 'Search';
}
export const FormField: (p: FormFieldProps) => JSX.Element = ({
  type,
  onChange,
  value,
  label,
  name,
  placeholder = ' ',
  ...rest
}) => (
  <>
    <EuiText style={{ fontWeight: '500', textAlign: 'left' }}>{label}</EuiText>
    {type === 'Text' && (
      <EuiFieldText
        {...rest}
        placeholder={placeholder}
        name={name}
        compressed={false}
        fullWidth={true}
        value={value}
        onChange={(e): void => {
          onChange(e.target.value);
        }}
      />
    )}
    {type === 'Password' && (
      <EuiFieldPassword
        {...rest}
        type="dual"
        placeholder={placeholder}
        name={name}
        compressed={false}
        fullWidth={true}
        value={value}
        onChange={(e): void => {
          onChange(e.target.value);
        }}
      />
    )}
    {type === 'Search' && (
      <EuiFieldSearch
        {...rest}
        placeholder={placeholder}
        value={value}
        isClearable={true}
        onChange={(e): void => {
          onChange(e.target.value);
        }}
      />
    )}
  </>
);
